module.exports = __webpack_public_path__ + "static/media/18-3.bee220ec.mp3";